import React, { ReactNode } from 'react';
import {
  GlobalStyle,
  RootWrapper,
} from '@app/ui/pages/landing-page/body/body.styles';

export const LayoutLandingPage: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const GlobalStyleComponent = GlobalStyle as any;
  return (
    <>
      <GlobalStyleComponent />
      <RootWrapper>
        {children}
      </RootWrapper>
    </>
  );
};
